// Copy for the factory claim page (/claim/:slug). Supplier-facing → Chinese
// (default) + English only, never Arabic. Chinese is hand-written for factories,
// not a literal translation. Priority message everywhere: FREE — no commission,
// no signup fee, no hidden costs. No fabricated numbers, no payment guarantees.

export const CLAIM_STRINGS = {
  zh: {
    brandSub: '连接沙特买家与优质中国供应商',
    tagline: '中国 → 沙特采购平台',
    eyebrow: '由 MAABAR 团队为您准备',
    title: '您的供应商主页已准备就绪',
    subtitle: '我们已为您整理公司信息、产品和目录，现在登录即可管理主页，连接更多沙特买家。',
    previewPublic: '查看公司主页预览 ›',
    verified: '已认证',

    // stats
    products: '产品', productsSub: '已为您整理',
    catalogs: '目录', catalogsSub: '产品目录',
    inquiries: '询盘', inquiriesSub: '等待响应',

    // free / no-fee highlight (high priority)
    highlight: '免费入驻，无佣金、无注册费、无隐藏费用。您的公司和产品将展示给沙特买家。',

    // sign-in card
    signinTitle: '登录管理您的主页',
    signinSub: '请输入您的账号，开始管理您的供应商主页',
    phone: '使用手机号登录',
    email: '使用邮箱继续',
    haveAccount: '已有账户？立即登录',
    dataSecurity: '我们重视您的数据安全，信息将被加密保护。',
    or: '或',

    // auth forms (kept)
    emailPh: '邮箱', phonePh: '手机号（如 +8613800138000）', passPh: '密码（至少 6 位）',
    claim: '确认所有权并开始', create: '创建账户并认领', enter: '进入您的后台', back: '← 返回',
    checkEmail: '请查收邮件确认，然后重新打开此链接。', working: '处理中…', loading: '加载中…',
    errPhone: '请输入有效的国际手机号。', errCreds: '手机号/邮箱或密码错误。',
    notfound: '此认领链接无效。',
    claimedOther: '该工厂已被其他账户认领。如果这是您，请联系客服。',
    claimedInfo: '该工厂主页已认领。如果是您的主页，请登录以进入并管理。',
    claimedSignout: '用其他账户登录',
    claimedSupport: '通过 WhatsApp 联系客服',
    waSupportText: '您好，我需要帮助访问我们在 Maabar 的工厂主页。',

    // inline code sign-in
    whatsapp: '使用 WhatsApp 接收验证码',
    newPassPh: '设置密码（至少 6 位）',
    sendCode: '发送验证码',
    codeSentTo: (v) => `验证码已发送至 ${v}，请在下方输入。`,
    codePh: '验证码',
    verifyBtn: '验证并登录',
    resend: '重新发送验证码',
    resendIn: (s) => `${s} 秒后可重新发送`,
    changeMethod: '更换验证方式',
    errEmail: '请输入有效的邮箱地址。',
    errCode: '验证码不正确或已过期，请重试。',
    errNoAccount: '未找到与此信息匹配的账户。',
    errSend: '验证码发送失败，请稍后重试或改用邮箱。',
    // Raised by claim_factory_by_slug once identity matching is on. Says WHICH
    // contact has to match and what to do next — a refusal the reader cannot act
    // on is a support ticket, and this one arrives at the moment they are
    // trying to join.
    errIdentityMismatch: '您登录所用的手机号或邮箱与我们记录中该工厂的联系方式不一致，因此无法认领此页面。请使用工厂登记的手机号或邮箱登录，或联系我们核实。',
    errNoContactOnFile: '我们的记录中没有该工厂的手机号或邮箱，无法核实所有权。请联系我们，我们会为您处理。',
    waNotReady: 'WhatsApp 验证码功能即将上线。目前请使用邮箱接收验证码。',
    waUseEmail: '改用邮箱接收验证码',

    // WhatsApp number — pre-filled from the invite, changeable
    phoneKnown: '验证码将发送至此号码',
    changeNumber: '更换号码',
    useSuggested: '使用建议的号码',
    phoneNatPh: '手机号',
    countrySearchPh: '搜索国家或区号',
    countryNone: '未找到匹配的国家或地区',
    skip: '查看公开页面',

    // products preview
    productsTitle: '我们已为您整理的产品',
    productsReady: '部分产品信息和价格已为您准备好',
    viewAll: (n) => `查看全部产品 (${n})`,
    priceTBD: '价格待更新',
    priceSet: '已设置价格',
    priceUnset: '未设置价格',
    moreProducts: (n) => `+${n} 个产品`,

    // completeness card
    completeTitle: '完善您的产品信息',
    completePct: '产品信息完整度',
    pricedLine: (x) => `${x} 个产品已设置价格`,
    unpricedLine: (y) => `${y} 个产品待更新价格`,
    completeHint: '更新价格可获得更多询盘',
    updateBtn: '更新产品与价格',

    // how it works
    howTitle: '如何通过 MAABAR 获得更多订单？',
    step1t: '沙特买家搜索产品', step1s: '买家在 MAABAR 平台搜索所需产品',
    step2t: 'MAABAR 团队匹配', step2s: '我们将买家需求匹配给合适的供应商',
    step3t: '您接收询盘与订单', step3s: '您将收到买家询盘，并有机会促成订单',

    // trust strip (first is emphasized)
    trust1: '供应商完全免费', trust2: '沙特专业采购平台',
    trust3: '中阿双语团队支持', trust4: '更多曝光与商机',

    footer: '连接沙特买家的桥梁',

    // post-claim pricing step (kept)
    claimedOk: '欢迎加入！', priceTitle: '为您的产品定价',
    priceSub: '设定价格，沙特买家即可下单 — 您随时可在后台逐个调整。',
    unpricedCount: (n) => `${n} 个产品尚未定价`,
    allPriced: '您的所有产品都已定价。', pricePh: '参考单价',
    applyBtn: '应用到未定价产品', appliedOk: '已应用 ✓ — 稍后可逐个调整。',
    perUnit: '/ 件', noPrice: '未定价', pricedTag: '已定价', toDashboard: '进入我的后台 →',
    priceErr: '请输入有效价格。',
  },

  en: {
    brandSub: 'Connecting Saudi buyers with quality Chinese suppliers',
    tagline: 'China → Saudi Arabia sourcing platform',
    eyebrow: 'Prepared for you by the MAABAR team',
    title: 'Your supplier page is ready',
    subtitle: "We've organized your company info, products, and catalogs — sign in to manage your page and reach more Saudi buyers.",
    previewPublic: 'Preview your public page ›',
    verified: 'Verified',

    products: 'Products', productsSub: 'organized for you',
    catalogs: 'Catalogs', catalogsSub: 'product catalogs',
    inquiries: 'Inquiries', inquiriesSub: 'awaiting reply',

    highlight: 'Free to join — no commission, no signup fee, no hidden costs. Your company and products are shown to Saudi buyers.',

    signinTitle: 'Sign in to manage your page',
    signinSub: 'Enter your account to start managing your supplier page',
    phone: 'Continue with Phone',
    email: 'Continue with Email',
    haveAccount: 'Already have an account? Sign in',
    dataSecurity: 'We take your data security seriously — your information is encrypted.',
    or: 'or',

    emailPh: 'Email', phonePh: 'Phone (e.g. +8613800138000)', passPh: 'Password (min 6 chars)',
    claim: 'Confirm ownership & start', create: 'Create account & claim', enter: 'Enter your dashboard', back: '← Back',
    checkEmail: 'Check your email to confirm, then reopen this link.', working: 'Working…', loading: 'Loading…',
    errPhone: 'Enter a valid international phone number.', errCreds: 'Wrong phone/email or password.',
    notfound: 'This claim link is not valid.',
    claimedOther: 'This factory has already been claimed by another account. Contact support if this is you.',
    claimedInfo: 'This factory page is already registered. If it belongs to you, sign in to enter and manage it.',
    claimedSignout: 'Sign in with a different account',
    claimedSupport: 'Contact support on WhatsApp',
    waSupportText: 'Hello, I need help accessing our factory page on Maabar.',

    // inline code sign-in
    whatsapp: 'Get a code on WhatsApp',
    newPassPh: 'Choose a password (at least 6 characters)',
    sendCode: 'Send code',
    codeSentTo: (v) => `We sent a code to ${v}. Enter it below.`,
    codePh: 'Verification code',
    verifyBtn: 'Verify & sign in',
    resend: 'Send a new code',
    resendIn: (s) => `You can resend in ${s}s`,
    changeMethod: 'Use a different method',
    errEmail: 'Enter a valid email address.',
    errCode: 'That code is incorrect or has expired. Please try again.',
    errNoAccount: 'No account matches those details.',
    errSend: "We couldn't send the code. Please try again, or use email.",
    // See the note on the Chinese copy.
    errIdentityMismatch: "The phone number or email you signed in with does not match the contact we hold for this factory, so the page cannot be claimed from this account. Please sign in with the factory's registered phone or email, or contact us and we will verify it with you.",
    errNoContactOnFile: 'We hold no phone number or email for this factory, so ownership cannot be verified automatically. Please contact us and we will sort it out for you.',
    waNotReady: 'WhatsApp codes are coming soon. For now, please use email to receive your code.',
    waUseEmail: 'Use email instead',

    // WhatsApp number — pre-filled from the invite, changeable
    phoneKnown: "We'll send the code to this number",
    changeNumber: 'Change number',
    useSuggested: 'Use suggested number',
    phoneNatPh: 'Phone number',
    countrySearchPh: 'Search country or code',
    countryNone: 'No matching country',
    skip: 'View public page',

    productsTitle: "Products we've organized for you",
    productsReady: 'Some product info and prices are ready',
    viewAll: (n) => `View all products (${n})`,
    priceTBD: 'Price to be updated',
    priceSet: 'Price set',
    priceUnset: 'No price yet',
    moreProducts: (n) => `+${n} products`,

    completeTitle: 'Complete your product info',
    completePct: 'product info complete',
    pricedLine: (x) => `${x} products have prices`,
    unpricedLine: (y) => `${y} products need prices`,
    completeHint: 'Updating prices brings more inquiries',
    updateBtn: 'Update products & prices',

    howTitle: 'How to get more orders through MAABAR?',
    step1t: 'Saudi buyers search products', step1s: 'Buyers search MAABAR for what they need',
    step2t: 'The MAABAR team matches', step2s: 'We match buyer needs to the right suppliers',
    step3t: 'You receive inquiries & orders', step3s: 'You get inquiries and chances to close orders',

    trust1: 'Completely free for suppliers', trust2: 'Saudi sourcing platform',
    trust3: 'Chinese–Arabic bilingual team', trust4: 'More exposure & opportunities',

    footer: 'Your bridge to Saudi buyers',

    claimedOk: 'Welcome aboard!', priceTitle: 'Price your products',
    priceSub: 'Set prices so Saudi buyers can order — you can fine-tune each product anytime in your dashboard.',
    unpricedCount: (n) => `${n} ${n === 1 ? 'product has' : 'products have'} no price yet`,
    allPriced: 'All your products are priced.', pricePh: 'Approx. price / unit',
    applyBtn: 'Apply to unpriced products', appliedOk: 'Prices applied ✓ — fine-tune each product later.',
    perUnit: '/ unit', noPrice: 'No price', pricedTag: 'Priced', toDashboard: 'Go to my dashboard →',
    priceErr: 'Enter a valid price.',
  },
};
